/**
 * 构建校验规则
 */
const generateValidateRule = ({name, rule, errMsg, required = false, requireMsg = ''}: {name: string; rule?: RegExp | Function; errMsg?: string; required: boolean; requireMsg: string;}) => {
    return {
        name,
        err: `${name}Err`,
        rule,
        errMsg: `${errMsg}` || '请输入正确的信息',
        required,
        requireMsg
    };
}

/**
 * 检查是否输入了emoji表情
 * @returns boolean
 */
const isEmojiCharacter = (substring): any => {
    for (let i = 0; i < substring.length; i++) {
        let hs = substring.charCodeAt(i);
        if (0xD800 <= hs && hs <= 0xDBFF) {
            if (substring.length > 1) {
                let ls = substring.charCodeAt(i + 1);
                let uc = ((hs - 0xD800) * 0x400) + (ls - 0xDC00) + 0x10000;
                if (0x1D000 <= uc && uc <= 0x1F77F) {
                    return true;
                }
            }
        } else if (substring.length > 1) {
            let ls = substring.charCodeAt(i + 1);
            // eslint-disable-next-line
            if (ls == 0x20E3) {
                return true;
            }
        } else {
            if (0x2100 <= hs && hs <= 0x27FF) {
                return true;
            } else if (0x2B05 <= hs && hs <= 0x2B07) {
                return true;
            } else if (0x2934 <= hs && hs <= 0x2935) {
                return true;
            } else if (0x3297 <= hs && hs <= 0x3299) {
                return true;
            // eslint-disable-next-line
            } else if (hs == 0xA9 || hs == 0xAE || hs == 0x303D || hs == 0x3030 || hs == 0x2B55 || hs == 0x2B1C || hs == 0x2B1B || hs == 0x2B50) {
                return true;
            }
        }
    }
};

export {
    generateValidateRule,
    isEmojiCharacter,
}